import { render, staticRenderFns } from "./landnum.vue?vue&type=template&id=0abd822c&scoped=true&"
import script from "./landnum.vue?vue&type=script&lang=js&"
export * from "./landnum.vue?vue&type=script&lang=js&"
import style0 from "./landnum.vue?vue&type=style&index=0&lang=css&"
import style1 from "./landnum.vue?vue&type=style&index=1&id=0abd822c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd822c",
  null
  
)

export default component.exports